<div class="flex h-full w-full flex-col gap-4 p-6">
  <div class="relative flex flex-col items-center justify-center gap-1">
    <span class="typo-h2 inline-flex text-text-primary">{{ dialogTitleTranslationKey() | translate }}</span>
    @if (data.treatment) {
      <div class="typo-h4-light flex gap-2">
        <span class="typo-h4-semibold text-primary-blue">{{ data.treatment.dentalCode }}</span>
        {{ data.treatment.description }}
      </div>
    }
    <button class="absolute right-0 top-0 inline-flex" (click)="onCloseClick()">
      <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
    </button>
  </div>
  @if (data.mode !== TeethSelectorMode.Full && data.mode !== TeethSelectorMode.SingleTooth && data.mode !== TeethSelectorMode.Range) {
    <lib-teeth-grid
      class="flex flex-1 justify-center overflow-hidden rounded-[40px]"
      [teeth]="data.teeth"
      [selectedTeethPositions]="selectedTeeth()"
      [drawTreatments]="treatmentSwitchControl.value"
      [mode]="data.mode"
      [selectedArch]="selectedArches()"
      [selectedQuadrant]="selectedQuadrants()"
      (archClicked)="onArchClick($event)"
      (quadrantClicked)="onQuadrantClick($event)"
      (toothClicked)="onToothClick($event)"
    />
  } @else {
    <div class="flex flex-1 justify-center overflow-hidden rounded-[40px] bg-background-white">
      <lib-teeth
        class="!w-auto"
        [teeth]="data.teeth"
        [drawGum]="false"
        [drawTreatments]="treatmentSwitchControl.value"
        [selectedTeethPositions]="selectedTeeth()"
        [highlightedTeethPositions]="highlightedTeeth()"
        (clicked)="onToothClick($event)"
        (hovered)="onToothHovered($event)"
      />
    </div>
  }

  <div class="flex items-center justify-between">
    <div class="flex flex-shrink-0 items-center gap-2">
      <lib-switch [formControl]="treatmentSwitchControl"></lib-switch>
      <span class="typo-h4-light">{{ 'common_teeth_selector_show_treatment_toggle' | translate }}</span>
    </div>
    <div class="flex items-center gap-4">
      <button class="btn-text" (click)="onCloseClick()">{{ 'charting_view_selection_cancel_button' | translate }}</button>
      <button class="btn-primary" [disabled]="isConfirmDisabled()" (click)="onConfirmClick()">
        {{ 'common_teeth_selector_confirm_button' | translate }}
      </button>
    </div>
  </div>
</div>
